import { createCampaign } from "../requests/Requests";

export async function addNewCampaign(dto) {

    const rawFolder = dto.folder?.folderPath?.replace(/^[\\\/]+/, '');

    const folderPath = rawFolder
        ? `${dto.jobNumber}\\${rawFolder}`
        : `${dto.jobNumber}`;

    const newCampaign = {
        jobNumber: dto.jobNumber,
        jobTitle: dto.jobName,
        comment: dto.comment,
        week: dto.week,
        year: parseInt(dto.year),
        customerIds: [parseInt(dto.customer)],
        tags: dto.tags,
        folderPath: dto.jobNumber,
        virtualFolder : dto.virtualFolder
    };
    const campaign = await createCampaign(newCampaign);
    return campaign;
}